import { Divider, Grid } from "@material-ui/core";
import Loading from "../../../components/basics/Loading";
import HeaderModule from "../../../components/header/HeaderModule";
import Filter from "./children/Filter";
import { ReportActions } from "./children/Report/ReportActions";
import ReportDataGrid from "./children/Report/ReportDataGrid";
import { ReportHeader } from "./children/Report/ReportHeader";
import {
  EspelhoFaturamentoContextProvider,
  useEspelhoFaturamentoService,
} from "./context/EspelhoFaturamentoContext";

const View = () => {
  const { isLoading, isRefetching } = useEspelhoFaturamentoService();

  return (
    <>
      <HeaderModule title={"ESPELHO DE FATURAMENTO"} />
      <Loading open={isLoading || isRefetching} />
      <Grid
        container
        direction="column"
        style={{ marginTop: 80, marginBottom: 40, padding: "0px 16px" }}
        spacing={2}
      >
        <Filter />

        <ReportHeader />
        <ReportActions />
        <Divider />

        <ReportDataGrid />
      </Grid>
    </>
  );
};

export default function EspelhoFaturamento() {
  return (
    <EspelhoFaturamentoContextProvider>
      <View />
    </EspelhoFaturamentoContextProvider>
  );
}
